import {css} from "@pandacss/css";
import {FC, ReactNode} from "react";

const scrollableSectionClass = css({
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden"
})

interface Props {
    height: number,
    children: ReactNode
}

const ScrollableSection: FC<Props> = ({height, children}) => {
    return <div className={scrollableSectionClass} style={{height: height}}>{children}</div>
}

export default ScrollableSection